import { apiService } from '../services/apiService'
import { API_BASE_URL } from '../config/api'

const postPropertyAction = async (propertyId, action, body) => {
  try {
    return await apiService.post(`/api/property/${encodeURIComponent(propertyId)}/${action}`, body)
  } catch (error) {
    if (/403/.test(error.message)) throw new Error('Úpravy nemovitostí jsou dostupné pouze administrátorům.')
    if (/400/.test(error.message)) throw new Error('Zkontrolujte vyplněný text a jeho délku.')
    throw new Error('Změnu se nepodařilo uložit. Zkontrolujte přihlášení a zkuste to znovu.')
  }
}

export const handleCommentSubmit = async (comment, propertyId, setProperty, setComment) => {
  if (!comment.trim()) return
  await postPropertyAction(propertyId, 'comment', { comment })
  setProperty(prev => ({ ...prev, comments: [...(prev.comments || []), { text: comment.trim(), date: new Date() }] }))
  setComment('')
}

export const handleGeneratePrompt = async (prompt, propertyId, setShowSubmitAnalysis) => {
  if (!prompt.trim()) return
  const result = await postPropertyAction(propertyId, 'generatePrompt', { promptDetails: prompt })
  setShowSubmitAnalysis(true)
  return result
}

export const handleSubmitAnalysis = async (analysis, propertyId, setShowSubmitAnalysis) => {
  if (!analysis.trim()) throw new Error('Nejprve vložte text analýzy.')
  const result = await postPropertyAction(propertyId, 'submitAnalysis', { analysis })
  setShowSubmitAnalysis(false)
  return result
}

export const getValueForProperty = async (propertyId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/value`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ propertyId }),
    })
    if (!response.ok) throw new Error('Failed to fetch value')
    return await response.json()
  } catch (error) {
    console.error('Error fetching value:', error)
    throw error
  }
}
